import { CommonModule } from '@angular/common'
import { Component, HostListener, Input, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { NetworkService } from 'src/app/service/network/network.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'
import { DdcUserSubscription } from '../../models/main/subscription'
import { DdcProfilePicComponent } from '../ddc-profile-pic/ddc-profile-pic.component'
@Component({
  selector: 'ddc-user-one',
  templateUrl: './ddc-user-one.component.html',
  styleUrl: './ddc-user-one.component.scss',
  imports: [AngularMaterialsModules, CommonModule, RouterModule, DdcProfilePicComponent],
})
export class DdcUserOneComponent implements OnInit {
  @Input('type') _type: string
  @Input('username') _username: string
  @Input('country') _country: string
  @Input('city') _city: string
  @Input('bio') _bio: string
  @Input('hasPic') _hasPic: boolean
  @Input('userProfilePic') _userProfilePic: string
  @Input('lng1') _lng_1: string
  @Input('lng2') _lng_2: string
  @Input('isProfilePicLoading') _isProfilePicLoading: boolean
  @Input('dynamicRoute') _dynamicRoute: string
  @Input('subscription') _subscription: DdcUserSubscription
  @Input('followersCount') followers_count: number
  @Input('verified') _verified: boolean = false

  _DefaultProfilePic: string = ''
  _buttonTitle: string = ''
  _showComponent = true
  showBiography = false

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  _isMobile = false

  constructor(
    private logger: DdcLoggerService,
    private network_srv: NetworkService,
    public themeService: ThemeService,
  ) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this._isMobile = event.target.innerWidth < 780
  }

  ngOnInit(): void {
    this.checkIfMobile()

    if (this._type === 'followers') {
      this._buttonTitle = 'Remove'
    } else if (this._type === 'following') {
      this._buttonTitle = 'Unfollow'
    }
  }

  checkIfMobile(): void {
    if (window.innerWidth < 780) {
      // 768px is a common breakpoint for mobile devices
      this._isMobile = true
    } else {
      this._isMobile = false
    }
  }

  toggleBio(): void {
    this.showBiography = !this.showBiography
  }

  actionClicked(): void {
    this.logger.info('DdcUserOneComponent actionClicked()')

    let followCommand = ''

    if (this._type === 'followers') {
      followCommand = 'remove'
    } else if (this._type === 'following') {
      followCommand = 'unfollow'
    }

    this.network_srv.command(this._username, followCommand).subscribe((res: any) => {
      this._showComponent = false
    })
  }
}
